import { USER_TRACKING_EVENTS } from "@website/tracking/tracking.types";
import { addEventToTracking } from "@website/tracking/user";

export const handleSearchInitiated = (data) => {
  addEventToTracking(USER_TRACKING_EVENTS.GENERAL_SEARCH, {
    product: "dom-hotel",
    ...data
  });
};

export const handleEventMapSearchClicked = (data) => {
  addEventToTracking(USER_TRACKING_EVENTS.MAP_SEARCH_CLICKED, {
    product: "dom-hotel",
    ...data
  });
};
